import { ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged } from 'rxjs';
import { EventBusService } from 'shared/services';

@Component({
    selector: 'app-feature-group-search',
    templateUrl: './feature-group-search.component.html',
    styleUrls: ['./feature-group-search.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, TranslateModule],
})
export class FeatureGroupSearchComponent implements OnInit {
    public searchForm: UntypedFormGroup = new UntypedFormGroup({
        search: new UntypedFormControl(''),
    });

    constructor(
        private destroyRef: DestroyRef,
        private eventBusService: EventBusService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.searchForm
            .get('search')!
            .valueChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
            .subscribe((value) => {
                this.eventBusService.dispatch('featureGroupSearch', value.toLowerCase());
            });

        this.eventBusService
            .getObservableForEventStream('tabChanged')
            .pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
            .subscribe(() => {
                this.searchForm.get('search')!.setValue('');
                this.eventBusService.dispatch('featureGroupSearch', undefined);
                this.cdr.detectChanges();
            });

        this.eventBusService
            .getObservableForEventStream('featureGroupSearch', true)
            .pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged())
            .subscribe((searchValue: any) => {
                this.searchForm.get('search')!.setValue(searchValue, { emitEvent: false });
            });
    }

    public clearSearch() {
        this.searchForm.get('search')!.setValue('');
        this.cdr.detectChanges();
    }
}
